const state = {
  sheduleOrder: {
    schedule_date: "",
    schedule_hour: "",
    commentStore: "",
    packedStore: true,
    cutleryStore: false,
    citys: []
  },
  zone: null
};

const getters = {};

const actions = {};

const mutations = {
  setSheduleOrder (state,data) {
    state.sheduleOrder = data;
  },
  setZone (state,data) {
    state.zone = data;
  },
  setCommentStore (state,data) {
    state.commentStore = data;
  },
  setPacketStore (state,data) {
    state.packedStore = data;
  },
  setCutleryStore (state,data) {
    state.cutleryStore = data;
  },
  setCitys (state,data) {
    state.citys = data;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};